import { useEffect } from 'react'

const PIXEL_ID = '3070568583125644'

export const useMetaPixel = () => {
  useEffect(() => {
    // Initialize Pixel
    const script = document.createElement('script')
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    noscript.innerHTML = `<img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1"
    />`
    document.body.appendChild(noscript)

    return () => {
      // Cleanup if needed, though usually pixel scripts persist
    }
  }, [])

  const trackEvent = (eventName: string, data?: any) => {
    if ((window as any).fbq) {
      ;(window as any).fbq('track', eventName, data)
    }
  }

  const trackCustom = (eventName: string, data?: any) => {
    if ((window as any).fbq) {
      ;(window as any).fbq('trackCustom', eventName, data)
    }
  }

  return { trackEvent, trackCustom }
}
